// extracted by mini-css-extract-plugin
var _1 = "AccountBody__activate--MFJvq AccountBody__activateBase--p4EP_ SchoolGeneral__button--ZIm36";
var _2 = "AccountBody__activateBase--p4EP_";
var _3 = "AccountBody__content--F8ymo";
var _4 = "AccountBody__deactivate--NetIY AccountBody__activateBase--p4EP_ SchoolGeneral__deactivate--gGnqC SchoolGeneral__button--ZIm36";
var _5 = "AccountBody__main--y1F6w";
var _6 = "AccountBody__notice--uqm1N SchoolGeneral__notice--w1WIt";
var _7 = "AccountBody__tabContent--chure";
var _8 = "AccountBody__top--hgTqS";
var _9 = "AccountBody__unassignedMessage--FbcNJ SchoolGeneral__textOnlyNotice--yqpRc";
export { _1 as "activate", _2 as "activateBase", _3 as "content", _4 as "deactivate", _5 as "main", _6 as "notice", _7 as "tabContent", _8 as "top", _9 as "unassignedMessage" }
